<template>
  <div>
    <!-- Header -->
    <div class="header bg-gradient-success py-7 py-lg-8 pt-lg-9">
      <b-container>
        <div class="header-body text-center mb-7">
          <b-row class="justify-content-center">
            <b-col xl="5" lg="6" md="8" class="px-5">
              <h1 class="text-white">Lock screen</h1>
              <p class="text-lead text-white">Better to be safe than sorry.</p>
            </b-col>
          </b-row>
        </div>
      </b-container>
      <div class="separator separator-bottom separator-skew zindex-100">
        <svg
          x="0"
          y="0"
          viewBox="0 0 2560 100"
          preserveAspectRatio="none"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <polygon
            class="fill-default"
            points="2560 0 2560 100 0 100"
          ></polygon>
        </svg>
      </div>
    </div>
    <!-- Page content -->
    <b-container class="mt--8 pb-5">
      <b-row class="justify-content-center">
        <b-col lg="5" md="7">
          <b-card no-body class="ard-profile bg-secondary mt-5">
            <b-row class="justify-content-center">
              <b-col lg="3" class="order-lg-2">
                <div class="card-profile-image">
                  <b-img
                    src="img/theme/team-4.jpg"
                    rounded="circle"
                    class="border-secondary"
                  />
                </div>
              </b-col>
            </b-row>
            <b-card-body class="pt-7 px-5">
              <div class="text-center mb-4">
                <h3>{{ model.firstName }} {{ model.lastName }}</h3>
              </div>
              <validation-observer
                v-slot="{ handleSubmit }"
                ref="formValidator"
              >
                <b-form role="form" @submit.prevent="handleSubmit(onSubmit)">
                  <base-input
                    alternative
                    prepend-icon="ni ni-lock-circle-open"
                    type="password"
                    placeholder="Password"
                    v-model="model.password"
                  >
                  </base-input>
                  <div class="text-center">
                    <base-button
                      type="primary"
                      native-type="submit"
                      class="mt-2"
                      >Unlock</base-button
                    >
                  </div>
                  <a href="/auth/login"> Back to Login</a>
                </b-form>
              </validation-observer>
            </b-card-body>
          </b-card>
          <b-row class="mt-3">
            <b-col cols="6">
              <router-link to="/auth/forgotpassword" class="text-light"
                ><small>Forgot password? </small></router-link
              >
              <div class="d-inline-flex p-3 mb-2">
                <b-form-radio
                  v-model="selected"
                  name="env"
                  value="development"
                  class="mr-2"
                  >DEV</b-form-radio
                >
                <b-form-radio v-model="selected" name="env" value="production"
                  >PROD</b-form-radio
                >
              </div>
            </b-col>
            <!-- <b-col cols="6" class="text-right">
              <router-link to="/register" class="text-light"
                ><small>Create new account</small></router-link
              >
            </b-col> -->
          </b-row>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import { APP_CONSTANT } from "../../constants/app.constant";
import swal from "sweetalert2";
export default {
  name: "lock",
  data() {
    return {
      model: {
        password: "",
        firstName: "",
        lastName: "",
        userName: "",
      },
      selected: "production",
    };
  },
  created() {
    if (localStorage.getItem(APP_CONSTANT.USER_ACCESS_TOKEN)) {
      let a = JSON.parse(localStorage.getItem(APP_CONSTANT.USER_INFO));
      this.model.firstName = a.firstName;
      this.model.lastName = a.lastName;
      this.model.userName = a.email;
    } else {
      this.$router.push( "/auth/login");
    }
    this.setEnv(this.selected);
  },
  watch: {
    selected: function (val) {
      this.setEnv(val);
      api = () => {};
      if (this.flag) window.location.reload();
    },
  },
  methods: {
    ...mapActions("user", ["setUserData", "setJWTToken", "setEnv"]),
    onSubmit() {
      let api = () => import("../../services/api.service");
      api().then(({ API }) => {
        API.LOGIN({
          userName: this.model.userName,
          password: this.model.password,
        })
          .then((res) => {
            try {
              if (res) {
                if (res.data.ok) {
                  if (
                    res.data.result.userData.role.includes("admin") ||
                    res.data.result.userData.role.includes("manager") ||
                    res.data.result.userData.role.includes("superAdmin")
                  ) {
                    this.setUserData(res.data.result.userData);
                    this.setJWTToken(res.data.result.auth_token);
                    localStorage.setItem(
                      APP_CONSTANT.USER_ACCESS_TOKEN,
                      res.data.result.auth_token
                    );
                    localStorage.setItem(
                      APP_CONSTANT.USER_INFO,
                      JSON.stringify(res.data.result.userData)
                    );
                    this.$router.push(
                      this.$route.query.redirect || "/dashboard"
                    );
                  } else throw "You are not authorized!";
                }
              } else {
                throw err;
              }
            } catch (e) {
              swal.fire({
                title: `${e}`,
                buttonsStyling: false,
                type: "warning",
                confirmButtonClass: "btn btn-danger btn-fill",
              });
            }
          })
          .catch((err) => {
            api = () => {};
            swal.fire({
              title: `${err}`,
              buttonsStyling: false,
              type: "error",
              confirmButtonClass: "btn btn-danger btn-fill",
            });
          });
      });
      // this will be called only after form is valid. You can do api call here to login
    },
  },
};
</script>
<style></style>
